import * as React from 'react';

import { ThemeProvider as AppThemeProvider, Theme, StyledEngineProvider } from '@mui/material';

import { defaultBranding, GenerateMuiTheme } from './styles/theme';


declare module '@mui/styles/defaultTheme' {
   
  interface DefaultTheme extends Theme {}
}


const ThemeProvider: React.FC = (props) => {
  return (
    <StyledEngineProvider injectFirst>
      <AppThemeProvider theme={GenerateMuiTheme(defaultBranding)}>
        {props.children}
      </AppThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
